import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews } from "@/utils/video";

interface HotRankingProps {
  items: Video[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <aside className="h-full rounded-lg border border-background-200/70 bg-background-100 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
          <i className="ri-fire-fill"></i>
        </span>
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950">热门榜单</h2>
          <p className="text-xs text-foreground-500">按观看热度实时排序 Top 10</p>
        </div>
      </div>
      <ol className="flex flex-col">
        {items.map((video, i) => (
          <li key={video.id}>
            <Link
              to={`/detail/${video.id}`}
              className="group flex items-center gap-3 rounded-md px-2 py-2 transition hover:bg-background-200/60"
            >
              <span
                className={`w-6 flex-none text-center font-heading text-sm font-bold ${
                  i < 3 ? "text-primary-500" : "text-foreground-500"
                }`}
              >
                {i + 1}
              </span>
              <div className="h-14 w-10 flex-none overflow-hidden rounded-md bg-background-200">
                <img
                  src={video.cover}
                  alt={`${video.title} 封面`}
                  title={`${video.title} 在线观看`}
                  className="h-full w-full object-cover object-top transition group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-400">
                  {video.title}
                </h3>
                <p className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                  <span>{video.type}</span>
                  <span className="text-foreground-300">·</span>
                  <span className="flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill text-[10px]"></i>
                    {video.rating.toFixed(1)}
                  </span>
                </p>
              </div>
              <span className="flex-none text-[11px] text-foreground-500">
                {formatViews(video.views)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}